require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.12@core-js/modules/es6.array.species.js
// module id = 0vzt
// module chunks = 16